import { useTranslation } from "react-i18next";
import AppTable, { ColumnConfig } from "../../../../components/AppTable/AppTable";
import TextPill from "../../../../components/TextPill";
import { COLOR } from "../../../../config/constraits";
import { SentimentAnalysisActions, PaginationSentimentAnalysis } from "../types";
import { SectionPermissionTypeEnum } from "../../../../types/SectionPermissionTypesEnum";

interface SentimentAnalysisTableProps {
    sentimentAnalysisData: PaginationSentimentAnalysis;
    totalPages: number;
    currentPage: number;
    pageSize: number;
    sentimentAnalysisActions?: SentimentAnalysisActions;
}

export default function SentimentAnalysisTable({
    sentimentAnalysisData,
    totalPages,
    currentPage,
    pageSize,
    sentimentAnalysisActions
}: SentimentAnalysisTableProps) {
    const { t } = useTranslation(["common", "dashboard", "claim"]);

    const columns: ColumnConfig<PaginationSentimentAnalysis["items"][number]>[] = [
        {
            header: t("claim:newClaimFeelingNote"),
            key: "value",
            render: (item) => <div style={{ textAlign: "center" }}>{item.value}</div>
        },
        {
            header: t("claim:newClaimFeeling"),
            key: "sentiment",
            render: (item) => {
                const sentimentKey = item.sentimentKey ?? "neutral";
                const sentimentBgColor =
                    sentimentKey === "negative" ? COLOR.VERMELL_LIGHT :
                    sentimentKey === "positive" ? COLOR.VERD_LIGHT :
                    COLOR.TARONJA;

                return (
                    <TextPill
                        label={item.sentiment}
                        backgroundColor={sentimentBgColor}
                        textColor="#000"
                    />
                );
            }
        },
        {
            header: t("sentiment:form.criteria"),
            key: "criteria"
        },
        //TODO: Descomentar campos de vigencia cuando estren en vigor.
        // {
        //     header: t("dashboard:filters.FechaEntrada"),
        //     key: "startDate",
        //     render: (item) => formatDate(item.startDate)
        // },
        // {
        //     header: t("dashboard:filters.FechaFinal"),
        //     key: "endDate",
        //     render: (item) => formatDate(item.endDate)
        // }
    ];

    return (
        <AppTable<PaginationSentimentAnalysis["items"][number]>
            data={sentimentAnalysisData.items || []}
            columns={columns}
            emptyMessage={t("claim:claimNoData")}
            t={t}
            hasActions={true}
            onDelete={sentimentAnalysisActions?.onDelete}
            onView={sentimentAnalysisActions?.onEdit}
            hasPagination={true}
            currentPage={currentPage}
            totalPages={totalPages}
            pageSize={pageSize}
            paginationType="sentimentAnalysis"
            sectionPermission={SectionPermissionTypeEnum.SENTIMENT_PARAMETERS}
        />
    );
}
